import * as EasyAsync from 'redux-easy-async';
import { JS_AUTH_TOOLS_ASYNC_MIDDLEWARE_TYPE } from "../constants";
/**
 * Creates an instance of asyncMiddleware to handle js auth tools async actions. Note: this will
 * only handle actions created by JS Auth Tools. If you wish to use create other async actions in
 * your own app you'll need to create your own instance of asyncMiddleware.
 * @name createAsyncMiddleware
 * @param  {object} requestOptions.IdentitySDK               an instance of IdentitySDK
 * @param  {string} requestOptions.identityApp               a valid app {@link
 * http://usejsdoc.org/index.html}. In most cases this will be `IdentitySDK.APPS.NERDWALLET_WEB`
 * @param  {array} [requestOptions.identityProfilesToInclude] Array of profiles that will be requested
 * with calls that return a logged in identity, i.e. register, signin, authenticateWithGoogle,
 * requestIdentity.
 * @param  {function} [requestOptions.getGoogleOAuthToken]     custom method for getting google oAuth
 * token. By default `authenticateWithGoogle` looks for an instance of `window.gapi`.
 * @return {function} Instance of redux middleware
 * @example
 * // typically this would where your redux store is created, e.g. `configureStore.js`.
 * // this assumes you already have an instance of `nwApiSDK`. See integrations steps if not.
 * // also assumes you have an array of middlewares `middlewares = []`
 * const asyncMiddleware = createAsyncMiddleware({
 *   IdentitySDK: nwApiSDK.IdentitySDK,
 *   IdentityProfilesToInclude: [
 *     nwApiSDK.IdentitySDK.PROFILES.GLOBAL_PROFILE,
 *     nwApiSDK.IdentitySDK.PROFILES.SUBSCRIPTION_PROFILE,
 *   ],
 *   identityApp: nwApiSDK.IdentitySDK.APPS.NERDWALLET_WEB,
 * });
 * middlewares.push(asyncMiddleware)
 */

export default (function () {
  var requestOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!requestOptions.IdentitySDK) {
    throw new Error('IdentitySDK is required');
  }

  if (!requestOptions.identityApp) {
    throw new Error('identityApp is required');
  }

  return EasyAsync.createAsyncMiddleware({
    namespace: JS_AUTH_TOOLS_ASYNC_MIDDLEWARE_TYPE,
    requestOptions: requestOptions
  });
});